var map = {
	"./3x3-basketball.svg": 7998,
	"./Vector-1.svg": 7589,
	"./Vector.svg": 8419,
	"./archery.svg": 9868,
	"./artistic_swimming.svg": 8369,
	"./athletics.svg": 7997,
	"./badminton.svg": 484,
	"./basketball.svg": 135,
	"./beach_volleyball.svg": 2838,
	"./boxing.svg": 6227,
	"./breaking.svg": 3365,
	"./canoe_slalom.svg": 6325,
	"./canoe_sprint.svg": 6663,
	"./cycling_bmx_freestyle.svg": 7717,
	"./cycling_bmx_racing.svg": 2806,
	"./cycling_mountain_bike.svg": 7059,
	"./cycling_road.svg": 9466,
	"./cycling_track.svg": 9237,
	"./diving.svg": 5065,
	"./equestrian.svg": 5401,
	"./fencing.svg": 1252,
	"./football.svg": 5105,
	"./golf.svg": 4658,
	"./green-check.svg": 4896,
	"./gym_art.svg": 8497,
	"./gymnastics_rhythmic.svg": 5459,
	"./handball.svg": 9926,
	"./hockey.png": 6867,
	"./hockey.svg": 5469,
	"./judo.svg": 6670,
	"./karate.svg": 5420,
	"./marathon_swimming.svg": 936,
	"./modern_pentathlon.svg": 1541,
	"./olympic-rings.svg": 7353,
	"./rowing.svg": 4110,
	"./rugby_sevens.svg": 2400,
	"./sailing.svg": 8399,
	"./shooting.svg": 3485,
	"./skateboarding.svg": 3184,
	"./sport_climbing.png": 5304,
	"./sport_climbing.svg": 7814,
	"./surfing.svg": 4586,
	"./swimming.svg": 4461,
	"./table_tennis.png": 9510,
	"./table_tennis.svg": 3532,
	"./taekwondo.svg": 3454,
	"./tennis.svg": 4967,
	"./trampoline.svg": 4163,
	"./triathlon.svg": 8385,
	"./volleyball.svg": 2566,
	"./water_polo.svg": 8742,
	"./weightlifting.svg": 9935,
	"./wrestling.svg": 5131,
	"./x3_basketball.svg": 8753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3334;